module.exports = __webpack_public_path__ + "img/41.f10baf30.png";